import React from 'react';
import { useTranslation } from 'next-i18next';

const SchoolTeachersTitle = () => {
  const { t } = useTranslation('common');
  return (
    <div className="school-overview-title">
      <h1 className="school-main-title h1">
        {t('service.school.certifiedTeachers.header')}
      </h1>
      <h2 className="school-main-subtitle">
        {t('service.school.certifiedTeachers.intro')}
      </h2>
    </div>
  );
};

export default SchoolTeachersTitle;
